import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { CommonService } from 'src/@services/common.service';
import { FormService } from 'src/@services/form.service';
import { CommonPagesService } from '../../common-pages.service';
import { ResponseStatus } from '../../enum';
@Component({
  selector: 'app-add-update-agency',
  templateUrl: './add-update-agency.component.html',
  styleUrls: ['./add-update-agency.component.scss'],
  standalone: false,
})
export class AddUpdateAgencyComponent implements OnInit {
  isVisibleAgencyDrawer = true;
  agencyDrawerTitle = 'Add Agency';
  isLoadingUploadSiteLogo = false;
  isLoadingUploadReportLogo = false;
  isLoadingOne = false;
  darkColorStyle: any;
  lightColorValidationColor: any;
  darkColorValidationColor: any;
  lightColorStyle: any;
  uploadResultSiteLogo: any = null;
  uploadResultReportLogo: any = null;
  uploadFlag: any = false;
  @Output() hideAgencyDrawer = new EventEmitter();
  @Input() selectedAgencyData: any;
  url: any;
  deleteIcon: any;
  userDetails: any;

  constructor(
    public _cs: CommonService,
    private _cpS: CommonPagesService,
    public _fS: FormService,
    private msg: NzMessageService
  ) {
    _fS.agencysForm_fb();
  }

  ngOnInit(): void {
    if (this.selectedAgencyData != null) {
      this.agencyDrawerTitle =
        'Edit Agency (' + this.selectedAgencyData.name + ')';

      this._fS.agencysForm.patchValue({
        agencyprofile: this.selectedAgencyData.profile,
        agencyName: this.selectedAgencyData.name,
        lightColor: this.selectedAgencyData.lightColor,
        darkColor: this.selectedAgencyData.darkColor,
        isActiveagency: this.selectedAgencyData.status,
      });
      this.lightColorStyle = this._fS.agencysForm.value.lightColor;
      this.darkColorStyle = this._fS.agencysForm.value.darkColor;
      if (this.uploadFlag == false) {
        this.uploadResultSiteLogo = this.selectedAgencyData.profile;
        this.uploadResultReportLogo = this.selectedAgencyData.reportProfile;

      }
    }
  }
  urlToFile(url: string, fileName: string, callback: (file: File) => void) {
    fetch(url)
      .then((response) => response.blob())
      .then((blob) => {
        const file = new File([blob], fileName, { type: blob.type });
        callback(file);
      })
      .catch((error) => console.error('Error converting URL to File:', error));
  }

  applyColorlightColor() {
    this.lightColorStyle = this._fS.agencysForm.value.lightColor;
  }

  applyColordarkColor() {
    this.darkColorStyle = this._fS.agencysForm.value.darkColor;
  }
  siteLogoFile: any;
  reportLogoFile: any;
  onFileChanged(e: any, isReportAgency: boolean, showMessage: boolean = true) {
    let reader = new FileReader();
    if (
      e.target.files[0].length > 0 ||
      e.target.files[0].type === 'image/jpeg' ||
      e.target.files[0].type === 'image/png' ||
      e.target.files[0].type === 'image/jpg'
    ) {
      const input = e.target as HTMLInputElement;
      this.url = e.target.files[0];
      if (isReportAgency) {
        this.reportLogoFile = e.target.files[0];
        this.reportImageResized = false;
      } else {
        this.siteLogoFile = e.target.files[0];
        this.siteImageResized = false;
      }

      reader.readAsDataURL(
        isReportAgency ? this.reportLogoFile : this.siteLogoFile
      );
      reader.onload = () => {
        this.url = reader.result;
        this._fS.fileupload.set(
          'File',
          isReportAgency ? this.reportLogoFile : this.siteLogoFile
        );
        this._fS.fileupload.set(
          'Screen',
          isReportAgency ? 'ReportAgencyProfile' : 'AgencyProfile'
        );
        if (isReportAgency) {
          this.isLoadingUploadReportLogo = false;
        } else {
          this.isLoadingUploadSiteLogo = false;
        } // this.isLoadingOne = true
        this._cpS.fileUpload(this._fS.fileupload).subscribe(
          (response: any) => {
            if (response.responseStatus == ResponseStatus.success) {
              if (isReportAgency) {
                this.uploadResultReportLogo = response.result[0];
                //add timestamp to avoid cache
                if (this.uploadResultReportLogo) {
                  this.uploadResultReportLogo =
                    this.uploadResultReportLogo + '?t=' + new Date().getTime();
                }

              } else {
                this.uploadResultSiteLogo = response.result[0];
                //add timestamp to avoid cache
                if (this.uploadResultSiteLogo) {
                  this.uploadResultSiteLogo =
                    this.uploadResultSiteLogo + '?t=' + new Date().getTime();
                }
              }

              showMessage
                ? this._cs.displayMessage('success', response.message)
                : '';
              input.value = null;
              // this.isLoadingOne = false
            } else {
              showMessage
                ? this._cs.displayMessage('error', response.message)
                : '';
              // this.isLoadingOne = false
              input.value = null;
            }
            if (isReportAgency) {
              this.isLoadingUploadReportLogo = false;
              input.value = null;
            } else {
              this.isLoadingUploadSiteLogo = false;
              input.value = null;
            }
          },
          (error: any) => {
            // this._cs.displayMessage('error', error.message);
            if (isReportAgency) {
              this.isLoadingUploadReportLogo = false;
              input.value = null;
            } else {
              this.isLoadingUploadSiteLogo = false;
              input.value = null;
            } // this.isLoadingOne = false
          }
        );
      };
    } else {
      this.msg.error('File type is not allowed');
      this.url = null;
      if (isReportAgency) {
        this.uploadResultReportLogo = null;
        this.isLoadingUploadReportLogo = null;
      } else {
        this.uploadResultSiteLogo = null;
        this.isLoadingUploadSiteLogo = false;
      }
      // this.isLoadingOne = false
    }
  }
  Onclick(e: any) {
    e.target.value = null;
  }
  resizeImage(
    file: File,
    maxWidth: number,
    maxHeight: number
  ): Promise<string> {
    return new Promise((resolve) => {
      const img = new Image();
      const reader = new FileReader();

      reader.onload = (event: any) => {
        img.src = event.target.result;
      };

      img.onload = () => {
        let width = img.width;
        let height = img.height;

        if (width > maxWidth) {
          height *= maxWidth / width;
          width = maxWidth;
        }
        if (height > maxHeight) {
          width *= maxHeight / height;
          height = maxHeight;
        }

        const canvas = document.createElement('canvas');

        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d')!;
        ctx.drawImage(img, 0, 0, width, height);

        const resizedImage =
          file.type === 'image/png'
            ? canvas.toDataURL('image/png') // PNG format preserves transparency
            : canvas.toDataURL('image/jpeg', 0.7); // JPEG format
        resolve(resizedImage); // Convert canvas to Base64
      };

      reader.readAsDataURL(file);
    });
  }

  siteImageResized: boolean = false;

  uploadResizedImage(file: File, maxWidth: number, maxHeight: number) {
    this.resizeImage(file, maxWidth, maxHeight).then((resizedImage) => {
      this.uploadResultSiteLogo = resizedImage; // Update UI with resized image

      // Convert base64 back to a Blob for uploading
      const resizedBlob = this.dataURLtoBlob(resizedImage);
      this.siteLogoFile = new File([resizedBlob], this.siteLogoFile.name, {
        type: this.siteLogoFile!.type,
      });

      this.onFileChanged({ target: { files: [this.siteLogoFile] } }, false, false);

      this.siteImageResized = true
      // this.msg.success('Image resized successfully!');
    });
  }
  reportImageResized: boolean = false;
  uploadResizedReportImage(file: File, maxWidth: number, maxHeight: number) {
    this.resizeImage(file, maxWidth, maxHeight).then((resizedImage) => {
      this.uploadResultReportLogo = resizedImage; // Update UI with resized image

      // Convert base64 back to a Blob for uploading
      const resizedBlob = this.dataURLtoBlob(resizedImage);
      this.reportLogoFile = new File([resizedBlob], this.reportLogoFile.name, {
        type: this.reportLogoFile!.type,
      });

      this.onFileChanged({ target: { files: [this.reportLogoFile] } }, true, false);

      // this.msg.success('Image resized successfully!');

      this.reportImageResized = true;
    });
  }
  // Convert Base64 to Blob for upload
  dataURLtoBlob(dataUrl: string): Blob {
    const arr = dataUrl.split(',');
    const mime = arr[0].match(/:(.*?);/)![1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
  }
  removeLogo(isReportAgency: boolean) {
    var requestBody = {
      screen: isReportAgency ? 'ReportAgencyProfile' : 'AgencyProfile',
      filename: isReportAgency
        ? this.uploadResultReportLogo
        : this.uploadResultSiteLogo,
    };
    this._cpS.fileDelete(requestBody).subscribe((response: any) => {
      if (response.responseStatus == ResponseStatus.success) {
        this._cs.displayMessage('success', response.message);

        this.url = '';
        this.deleteIcon = false;
        if (isReportAgency) {
          this.uploadResultReportLogo = null;
        } else {
          this.uploadResultSiteLogo = null;
        }
      } else {
        this._cs.displayMessage('error', response.message);
      }
    });

    // this._cs.displayMessage('success', 'Image deleted successfully');
  }

  //cancel update Agency
  handleCancel() {
    this.isVisibleAgencyDrawer = false;
    this.hideAgencyDrawer.emit({
      hide: this.isVisibleAgencyDrawer,
      data: null,
    });
  }

  broofa() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
      /[xy]/g,
      function (c) {
        var r = (Math.random() * 16) | 0,
          v = c == 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );
  }
  //add/update Agency
  handleOk() {
    if (this._fS.agencysForm.valid) {
      const formValue = this._fS.agencysForm.value;
      var agencyBody = {
        Id:
          this.selectedAgencyData != null
            ? this.selectedAgencyData.id
            : this.broofa(),
        Name: formValue.agencyName.trim(),
        Profile: this.uploadResultSiteLogo,
        ReportProfile: this.uploadResultReportLogo,
        LightColor: formValue.lightColor,
        DarkColor: formValue.darkColor,
        Status: formValue.isActiveagency == true ? 1 : 0,
      };
      //add or edit unit data
      if (this.selectedAgencyData != null) {
        this.UpdateAgencyData(agencyBody);
      } else {
        this.addAgencyData(agencyBody);
      }
    } else {
      //to fire validations on invalid fields
      this.darkColorValidationColor =
        this._fS.agencysForm.controls.darkColor.status;
      this.lightColorValidationColor =
        this._fS.agencysForm.controls.lightColor.status;
      this._cs.markFormGroupTouched(this._fS.agencysForm);
    }
  }

  //api call to add/update agency
  addAgencyData(agencyBody: any) {
    this.isLoadingOne = true;
    // agencyBody = JSON.stringify(agencyBody)
    this._cpS.createAgency(agencyBody).subscribe(
      (response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          this._cs.displayMessage('success', response.message);

          //hide unit drawer
          this.isVisibleAgencyDrawer = false;
          this.hideAgencyDrawer.emit({
            hide: this.isVisibleAgencyDrawer,
            data: response.result,
          });
          this.isLoadingOne = false;
        } else {
          this._cs.displayMessage('error', response.message);
          this.isLoadingOne = false;
        }
      },
      (error: any) => {
        // this._cs.displayMessage('error', error.message);
        this.isLoadingOne = false;
      }
    );
  }
  //api call to add/update agency
  UpdateAgencyData(agencyBody: any) {
    this.isLoadingOne = true;
    this._cpS.updateAgency(agencyBody).subscribe(
      (response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          this._cs.displayMessage('success', response.message);

          //hide unit drawer
          this.isVisibleAgencyDrawer = false;
          this.hideAgencyDrawer.emit({
            hide: this.isVisibleAgencyDrawer,
            data: response.result,
          });
          this.isLoadingOne = false;
        } else {
          this._cs.displayMessage('error', response.message);
          this.isLoadingOne = false;
        }
      },
      (error: any) => {
        // this._cs.displayMessage('error', error.message);
        this.isLoadingOne = false;
      }
    );
  }
}
